import { render } from "./logo.vue?vue&type=template&id=26843fb8&scoped=true&ts=true"
import script from "./logo.vue?vue&type=script&lang=ts"
export * from "./logo.vue?vue&type=script&lang=ts"

import "./logo.vue?vue&type=style&index=0&id=26843fb8&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26843fb8"],['__file',"src/layout/components/logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26843fb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26843fb8', __exports__)) {
    console.log('reload')
    api.reload('26843fb8', __exports__)
  }
  
  module.hot.accept("./logo.vue?vue&type=template&id=26843fb8&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('26843fb8', render)
  })

}


export default __exports__